export const debounce = (fn: any, delay = 200) => {
	let t: ReturnType<typeof setTimeout>;
	return (...args: any[]) => {
		clearTimeout(t);
		t = setTimeout(() => fn(...args), delay);
	};
};
